import { render, staticRenderFns } from "./DuplicateEventAction.vue?vue&type=template&id=17b23589"
import script from "./DuplicateEventAction.vue?vue&type=script&lang=js"
export * from "./DuplicateEventAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports